/*/
 * Nav aligner
/*/
	const siteNavWidth = () => {
		const width = document.querySelector('.header--items').offsetWidth
		const lang = document.querySelector('.header--lang')?.offsetWidth ?? 0

		document.documentElement.style.setProperty('--nav-width', `${width + lang}px`)
	}

	window.addEventListener('load', siteNavWidth())
	window.addEventListener('resize', () => {
		setTimeout(() => {
			siteNavWidth()
		}, 100);
	})


/*/
 * Counter
/*/
	const counterScroll = _ => {
		const scrollElements = document.querySelectorAll('[site-counter]')
		const scrollObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry, i) => {
				if (entry.isIntersecting && !entry.target.classList.contains('is--counted')) {
					let _this = entry.target
					_this.classList.add('is--counted')

					let symbol = _this.dataset.symbol ? _this.dataset.symbol : ''
					let milhar = _this.dataset.milhar == 'off' ? true : false
					let language = document.documentElement.lang

					let start = 0
					let end = _this.dataset.count
					let step = end / 200

					setTimeout(_ => {
						let interval = setInterval(() => {
							let counter = start += step

							if (!milhar) {
								_this.innerHTML = symbol + parseInt(counter).toLocaleString(language)
							} else {
								_this.innerHTML = symbol + parseInt(counter)
							}

							if (start > end) {
								clearInterval(interval);
								if (!milhar) {
									_this.innerHTML = symbol + parseInt(end).toLocaleString(language)
								} else {
									_this.innerHTML = symbol + parseInt(end)
								}
							}
						}, 10);
					}, 100 * (i + 1))
				}
			})
		}, {
			threshold: 0.5
		})

		scrollElements.forEach(target => scrollObserver.observe(target))
	}

	window.addEventListener('load', function () {
		setTimeout(() => {
			counterScroll()
		}, 100)
	})
